/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addCardNotification } from '../fn/user-stripe-payments-api/add-card-notification';
import { AddCardNotification$Params } from '../fn/user-stripe-payments-api/add-card-notification';
import { createBookingPaymentIntent } from '../fn/user-stripe-payments-api/create-booking-payment-intent';
import { CreateBookingPaymentIntent$Params } from '../fn/user-stripe-payments-api/create-booking-payment-intent';
import { createSetupIntent } from '../fn/user-stripe-payments-api/create-setup-intent';
import { CreateSetupIntent$Params } from '../fn/user-stripe-payments-api/create-setup-intent';
import { createSubscriptionPaymentIntent } from '../fn/user-stripe-payments-api/create-subscription-payment-intent';
import { CreateSubscriptionPaymentIntent$Params } from '../fn/user-stripe-payments-api/create-subscription-payment-intent';
import { deleteCustomerPaymentMethod } from '../fn/user-stripe-payments-api/delete-customer-payment-method';
import { DeleteCustomerPaymentMethod$Params } from '../fn/user-stripe-payments-api/delete-customer-payment-method';
import { finishPayment } from '../fn/user-stripe-payments-api/finish-payment';
import { FinishPayment$Params } from '../fn/user-stripe-payments-api/finish-payment';
import { getCustomerPaymentIntents } from '../fn/user-stripe-payments-api/get-customer-payment-intents';
import { GetCustomerPaymentIntents$Params } from '../fn/user-stripe-payments-api/get-customer-payment-intents';
import { getCustomerPaymentMethods } from '../fn/user-stripe-payments-api/get-customer-payment-methods';
import { GetCustomerPaymentMethods$Params } from '../fn/user-stripe-payments-api/get-customer-payment-methods';
import { getStripePublicKey } from '../fn/user-stripe-payments-api/get-stripe-public-key';
import { GetStripePublicKey$Params } from '../fn/user-stripe-payments-api/get-stripe-public-key';
import { PaymentInfoDto } from '../models/payment-info-dto';
import { PaymentMethodDto } from '../models/payment-method-dto';
import { SetupIntentInfo } from '../models/setup-intent-info';
import { SimpleValue } from '../models/simple-value';
import { StripePaymentIntentResponse } from '../models/stripe-payment-intent-response';

@Injectable({ providedIn: 'root' })
export class UserStripePaymentsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createSubscriptionPaymentIntent()` */
  static readonly CreateSubscriptionPaymentIntentPath = '/api/user/payments/stripe/subscription';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscriptionPaymentIntent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionPaymentIntent$Response(params: CreateSubscriptionPaymentIntent$Params, context?: HttpContext): Observable<StrictHttpResponse<StripePaymentIntentResponse>> {
    return createSubscriptionPaymentIntent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubscriptionPaymentIntent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionPaymentIntent(params: CreateSubscriptionPaymentIntent$Params, context?: HttpContext): Observable<StripePaymentIntentResponse> {
    return this.createSubscriptionPaymentIntent$Response(params, context).pipe(
      map((r: StrictHttpResponse<StripePaymentIntentResponse>): StripePaymentIntentResponse => r.body)
    );
  }

  /** Path part for operation `createSetupIntent()` */
  static readonly CreateSetupIntentPath = '/api/user/payments/stripe/paymentmethod';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSetupIntent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupIntent$Response(params: CreateSetupIntent$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupIntentInfo>> {
    return createSetupIntent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSetupIntent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupIntent(params: CreateSetupIntent$Params, context?: HttpContext): Observable<SetupIntentInfo> {
    return this.createSetupIntent$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetupIntentInfo>): SetupIntentInfo => r.body)
    );
  }

  /** Path part for operation `deleteCustomerPaymentMethod()` */
  static readonly DeleteCustomerPaymentMethodPath = '/api/user/payments/stripe/paymentmethod';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCustomerPaymentMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteCustomerPaymentMethod$Response(params: DeleteCustomerPaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCustomerPaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCustomerPaymentMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteCustomerPaymentMethod(params: DeleteCustomerPaymentMethod$Params, context?: HttpContext): Observable<void> {
    return this.deleteCustomerPaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addCardNotification()` */
  static readonly AddCardNotificationPath = '/api/user/payments/stripe/paymentMethodNotification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCardNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  addCardNotification$Response(params?: AddCardNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addCardNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addCardNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addCardNotification(params?: AddCardNotification$Params, context?: HttpContext): Observable<void> {
    return this.addCardNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `finishPayment()` */
  static readonly FinishPaymentPath = '/api/user/payments/stripe/finish';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `finishPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  finishPayment$Response(params: FinishPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return finishPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `finishPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  finishPayment(params: FinishPayment$Params, context?: HttpContext): Observable<void> {
    return this.finishPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createBookingPaymentIntent()` */
  static readonly CreateBookingPaymentIntentPath = '/api/user/payments/stripe/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBookingPaymentIntent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBookingPaymentIntent$Response(params: CreateBookingPaymentIntent$Params, context?: HttpContext): Observable<StrictHttpResponse<StripePaymentIntentResponse>> {
    return createBookingPaymentIntent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBookingPaymentIntent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBookingPaymentIntent(params: CreateBookingPaymentIntent$Params, context?: HttpContext): Observable<StripePaymentIntentResponse> {
    return this.createBookingPaymentIntent$Response(params, context).pipe(
      map((r: StrictHttpResponse<StripePaymentIntentResponse>): StripePaymentIntentResponse => r.body)
    );
  }

  /** Path part for operation `getCustomerPaymentMethods()` */
  static readonly GetCustomerPaymentMethodsPath = '/api/user/payments/stripe/paymentmethods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerPaymentMethods()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPaymentMethods$Response(params?: GetCustomerPaymentMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentMethodDto>>> {
    return getCustomerPaymentMethods(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerPaymentMethods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPaymentMethods(params?: GetCustomerPaymentMethods$Params, context?: HttpContext): Observable<Array<PaymentMethodDto>> {
    return this.getCustomerPaymentMethods$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentMethodDto>>): Array<PaymentMethodDto> => r.body)
    );
  }

  /** Path part for operation `getCustomerPaymentIntents()` */
  static readonly GetCustomerPaymentIntentsPath = '/api/user/payments/stripe/paymentintents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerPaymentIntents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPaymentIntents$Response(params: GetCustomerPaymentIntents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentInfoDto>>> {
    return getCustomerPaymentIntents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerPaymentIntents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPaymentIntents(params: GetCustomerPaymentIntents$Params, context?: HttpContext): Observable<Array<PaymentInfoDto>> {
    return this.getCustomerPaymentIntents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentInfoDto>>): Array<PaymentInfoDto> => r.body)
    );
  }

  /** Path part for operation `getStripePublicKey()` */
  static readonly GetStripePublicKeyPath = '/api/user/payments/stripe/key';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStripePublicKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStripePublicKey$Response(params?: GetStripePublicKey$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleValue>> {
    return getStripePublicKey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStripePublicKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStripePublicKey(params?: GetStripePublicKey$Params, context?: HttpContext): Observable<SimpleValue> {
    return this.getStripePublicKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleValue>): SimpleValue => r.body)
    );
  }

}
